import AccountsLayout from "./AccountsLayout";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useStore } from "../../Components/StateProvider";
import {
  URLPRIFIX,
  GetRecords,
  GetDateTimeFormat,
  RupeeFormatWithoutDecimal,
  formatDate,
} from "../../functions/api";
import CompanyList from "../../Components/Elements/CompanyList";
import DateRangePicker from "../../Components/Elements/DateRangePicker";
import ProfitLossChart from "../../Components/Elements/ProfitLossChart";
import CustomPieChart from "../../Components/Elements/CustomPieChart";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { FaEye } from "react-icons/fa";
import dayjs from "dayjs";

const AccountsDashboard = () => {
  const store = useStore();
  const { companyId } = useParams();

  // const [companyId, setCompanyId] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dashboardData, setDashboardData] = useState({
    total_revenue: 0,
    total_expense: 0,
    net_profit: 0,
    blnc:0,
    invoiceData: [],
    upcomingDueDates: [],
    upcomingoverdue: [],
    coreManagement: [],
  });

  useEffect(() => {
     const dateTime = GetDateTimeFormat();
        //  loadRecord(dateTime.yearStartDate + "Z",dateTime.yearEndDate + "Z");

    const url = `/api/v2/accounting/getdashboarddata/${companyId}?startDate=${
      startDate
        ? dateTime.yearStartDate + "Z"
        : dateTime.yearStartDate + "Z"
    }&endDate=${
      endDate
        ? dateTime.yearEndDate + "Z"
        : dateTime.yearEndDate + "Z"
    }`;
    console.log(" company id ", companyId);
    GetRecords(url).then((res) => {
      console.log(" company id res", res);
      if (res.success) {
        setDashboardData(res.record);
      } else {
        console.error("Failed to fetch dashboard data");
      }
    });
  }, [companyId, startDate, endDate]);
  useEffect(() => {
    store.setmodule("companydashboard").then((res) => {
      store.stopLoading();
      store.setheader("Accounting Dashboard");
    });
  }, []);
  const handlePeriodChange = (period) => {
    const today = dayjs();
    if (period === "Monthly") {
      setStartDate(today.startOf("month").format("YYYY-MM-DD"));
      setEndDate(today.endOf("month").format("YYYY-MM-DD"));
    } else if (period === "Yearly") {
      setStartDate(today.startOf("year").format("YYYY-MM-DD"));
      setEndDate(today.endOf("year").format("YYYY-MM-DD"));
    }
  };
  return (
    <div className="h-screen  p-3 flex flex-col gap-5">
      {/* top 4 cards */}
      <div className="grid grid-cols-4 gap-5">
        <div className="bg-white border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/bar-chart.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">
              Total Revenue
            </h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.total_revenue)}{" "}
          </div>
          <div className="text-black-500 text-xs">
            {/* INCREASE <span className="text-black-600 font-semibold">12%</span> VS LAST MONTH */}
          </div>
        </div>

        <div className="bg-white border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/expense.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">
              Total Expense
            </h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.total_expense)}{" "}
          </div>
          <div className="text-black-500 text-xs"></div>
        </div>
        <div className="bg-white border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/profit.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">
              Net Profit/Loss
            </h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.net_profit)}{" "}
          </div>
          <div className="text-black-500 text-xs"></div>
        </div>
        <div className="bg-White border border-[#E0E0E0] shadow-xl rounded-lg p-4 h-28">
          <div className="flex items-center">
            <img
              className="h-5 w-6"
              src="/Assets/images/cashflow.png"
              alt="Chart"
            />
            <h4 className="text-gray-600 text-lg font-medium ml-2">Balance</h4>
          </div>
          <div className="font-bold p-2 text-3xl text-[#000048]">
            ₹ {RupeeFormatWithoutDecimal(dashboardData.blnc)}{" "}
          </div>
          <div className="text-black-500 text-xs"></div>
        </div>
      </div>

      {/* 2 Charts */}
      <div className="grid grid-cols-7 gap-5">
        <div className="bg-white border border-[#C0C0C0] shadow-2xl rounded-lg p-4 h-80 col-span-4 ">
          <ProfitLossChart
            total_revenue={dashboardData?.total_revenue}
            total_expense={dashboardData?.total_expense}
            net_profit={dashboardData?.net_profit}
            onPeriodChange={handlePeriodChange}
          />
        </div>
        <div className="bg-white border border-[#C0C0C0] shadow-2xl rounded-lg p-4 h-80 col-span-3 ">
          <CustomPieChart
            coreManagement={dashboardData?.coreManagement}
            onPeriodChange={handlePeriodChange}
          />
        </div>
      </div>

      {/* Bottom 3 Sections - Adjusted Heights */}
      <div className="grid grid-cols-8 gap-5">
        {/* Invoice Management */}
        <div className="col-span-3 bg-white border border-gray-300 shadow-2xl rounded-lg p-4 h-80">
          <h2 className="text-lg font-semibold text-gray-800 mb-3">
            Invoice Management
          </h2>
          <div className="flex items-center justify-between">
            <ResponsiveContainer width={250} height={250}>
              <PieChart>
                <Pie
                  data={dashboardData?.invoiceData?.map((item) => ({
                    ...item,
                    value: Number(item.value) || 0, // Ensure value is a number
                  }))}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={30} // Donut Effect
                  outerRadius={65}
                  paddingAngle={1}
                  label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                >
                  {dashboardData?.invoiceData?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            {/* Side Indicators */}
            <div className="flex flex-col gap-3">
              {dashboardData?.invoiceData?.map((entry, index) => (
                <div key={index} className="flex items-center gap-2">
                  <div
                    className="w-4 h-4 rounded-full"
                    style={{ backgroundColor: entry.color }}
                  ></div>
                  <span className="text-sm font-medium">{entry.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-span-2 bg-white border border-gray-300 shadow-2xl rounded-lg p-4 h-80 overflow-y-auto">
          <h2 className="text-xl font-bold">Upcoming Invoice Due's</h2>
          &nbsp;
          {dashboardData?.upcomingDueDates?.map((item, index) => (
            <div key={index} className="mb-3">
              <p className="text-sm text-gray-600">{item.invoice_no}</p>
              <p className="font-semibold">{item.customer_name}</p>
              <p className="text-xs text-gray-500">
                Due Date: {formatDate(item.due_date)}
              </p>
            </div>
          ))}
        </div>

        {/* Calendar View */}
        <div className="col-span-3 bg-white border border-gray-300 shadow-md rounded-lg p-4 h-80 overflow-y-auto">
          <h2 className="text-xl font-bold">Overdue Payments</h2>
          &nbsp;
          {dashboardData?.upcomingoverdue?.map((item, index) => (
            <div key={index} className="mb-3">
              <p className="text-sm text-gray-600">{item.invoice_no}</p>
              <p className="font-semibold">{item.customer_name}</p>
              <p className="text-xs text-gray-500">
                Due Date: {formatDate(item.due_date)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccountsDashboard;
